var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import classNames from "classnames";
export const QuiAvatar = forwardRef((_a, ref) => {
    var { children, size, active, variant, className } = _a, otherProps = __rest(_a, ["children", "size", "active", "variant", "className"]);
    const avatarClassName = classNames("qui-avatar", className, {
        "qui-avatar-sm": size === "sm",
        "qui-avatar-md": size === "md" || !size,
        "qui-avatar-light": variant === "light",
        "qui-avatar-dark": variant === "dark" || !variant,
        "qui-avatar-active": active,
    });
    return (React.createElement("button", Object.assign({}, otherProps, { className: avatarClassName, ref: ref }), children));
});
QuiAvatar.displayName = "QuiAvatar";
